import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=8e2b2f66&scoped=true"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"
import style0 from "./Holidays.vue?vue&type=style&index=0&id=8e2b2f66&prod&lang=css"
import style1 from "./Holidays.vue?vue&type=style&index=1&id=8e2b2f66&prod&scoped=true&lang=css"
import style2 from "./Holidays.vue?vue&type=style&index=2&id=8e2b2f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2b2f66",
  null
  
)

export default component.exports